<!-- Filter -->
<!-- <app-conditions-filter [filterData]="'products'" (applyFormData)="applyFilterData($event)" (resetFormData)="resetFilter()"></app-conditions-filter>  -->

<div [ngClass]="{'backdrop': hiddenCategory || hiddenFilter}">
    <!-- Catalog -->
    
    <!-- <div class="row"> -->
    
        <!-- <div *ngIf="permissionAccess.check('REFERENCES_CATEGORIES')" class="filter-category" [ngClass]="{'close-filter-category': filterCategoryStatus}" style="padding-right:0;"> -->
    
        <div [ngClass]="hiddenCategory ? 'filter-category_state' : 'hidden'">
    
            <app-tree-view (changeItem)="eventCategoryList($event)" (hiddenCategory)="eventCloseCategory($event)" [categoryType]="categoryType" [categoryIds]="categoriesIds"></app-tree-view>
    
        </div>

        <div [ngClass]="hiddenFilter ? 'filter-category_state filter_state' : 'hidden'">
    
            <app-conditions-filter [filterData]="'products'" (applyFormData)="applyFilterData($event)" (hiddenFilter)="eventCloseFilter($event)" (resetFormData)="resetFilter()"></app-conditions-filter>
    
        </div>
    
        <!-- <div class="col-9" [ngClass]="{'col-12': filterCategoryStatus}"> -->
        <!-- <div class="col-12"> -->
            <div class="card card-tools">
    
                <div class="card-header">
                    <div class="tools d-flex justify-content-between">
                        <div class="tools-position">
                            <!-- Выпадающий список с доступными действиям -->
                            <ff-actions-menu *ngIf="checkedCheckBox()" [configuredAttirubes]="configuredAttirubes"
                                [actionListData]="actionsList" [listData]="products" [ids]="allIds"
                                (changeValue)="getList()" [selectedFiles]="countSelectedFiles"
                                (deletedData)="onConfirm($event)"></ff-actions-menu>
                            <!-- <app-ff-actions-menu *ngIf="checkedCheckBox()" class="action-menu" [actionListData]="actionsList" [listData]="tyOfSelectedFiles == null ? products : allProducts"
                            (changeValue)="getList()" (deletedData)="onConfirm($event)"></app-ff-actions-menu> -->
    
                            <!-- <app-change-state *ngIf="permissionAccess.check('PRODUCT_STATE_APPROVED')"
                        (updateEvent)="reloadList()" [_objectData]="{productsData: productsData, module: 'products'}"></app-change-state>
                             -->
                            <!-- <button *ngIf="permissionAccess.check('REFERENCES_CATEGORIES')"  type="button" class="btn btn-light btn-sm"  (click)="toggleCategoryBox()"> -->
                            <button [ngClass]="{'ml-0': !checkedCheckBox()}" *ngIf="permissionAccess.check('REFERENCES_CATEGORIES')" type="button"
                                class="btn btn-light btn-sm btn-category" (click)="hiddenCategory = !hiddenCategory">
                                <!-- class="btn btn-light btn-sm"  (click)="opneCategory()" > -->
                                <!-- <i class="bi category-icon"><img class="th-icon"
                                        src="/assets/images/icons/category.svg"></i> -->
                                        <svg-icon src="/assets/images/icons/category.svg" [stretch]="true"
                                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                        <span class="btn-span">{{ 'CATEGORIES' | translate }}</span>
                                        
                            </button>
    
                            <button type="button" class="btn btn-light btn-sm btn-category" (click)="hiddenFilter = !hiddenFilter">
                                <!-- <i class="bi category-icon"><img class="th-icon" src="/assets/images/icons/filter2.svg"></i> -->
                                <svg-icon src="/assets/images/icons/filter2.svg" [stretch]="true"
                                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                <span class="btn-span" >{{ 'Фильтр' | translate }}</span>
                            </button>

                            <button *ngIf="isFilterActive()" type="button"
                                class="btn btn-light btn-sm btn-category btn-reset-filter"
                                (click)="resetFilter()"
                                ngbTooltip="Сбросить фильтр" tooltipClass="clue-name" placement="bottom">
                                <svg-icon src="/assets/images/icons/refresh.svg" [stretch]="true"
                                [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                <span class="btn-span">{{ 'Сбросить фильтр' | translate }}</span>
                            </button>

                            <button *ngIf="checkRole" type="button" class="btn btn-primary btn-sm" (click)="customerIntegration()">
                                <i class="bi-check2-square"></i>
                                <span class="btn-span">Интеграция c поставщиками</span>
                            </button>
    
                        </div>
                        <div class="tools-position">
                            <button *ngIf="permissionAccess.check('PRODUCT_CREATE')" type="button"
                                class="btn btn-primary btn-sm btn-add" routerLink="/products/create">
                                <!-- <i class="bi bi-plus-circle"></i> -->
                                <svg-icon src="/assets/images/icons/add.svg" [stretch]="true"
                                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                <span>{{ 'ADD' | translate }}</span>
                            </button>
    
                            <button type="button" class="btn btn-none btn-sm p-0 tools-right" autoClose="true" [closeDelay]="300" tooltipClass="clue-name" ngbTooltip="Сбросить" placement="auto"
                                (click)="resetFilter()">
                                <!-- *ngIf="permissionAccess.check('REFERENCES_ATTRIBUTES') && !settingVue" -->
                                <!-- <i class="bi mr-0"><img class="th-icon" src="/assets/images/icons/refresh.svg"></i> -->
                                <svg-icon class="" src="/assets/images/icons/refresh.svg" [stretch]="true"
                                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                            </button>
    
                            <!-- ВЕРСИЯ С ОКНОМ -->
                            <button type="button" class="btn btn-none btn-sm p-0 tools-right"
                                ngbTooltip="{{ 'Настройка атрибутов' | translate }}" autoClose="true"  [closeDelay]="300" tooltipClass="clue-name" placement="left" (click)="attrsSettings()">
                                <!-- *ngIf="permissionAccess.check('REFERENCES_ATTRIBUTES') && !settingVue" -->
                                <!-- <i class="bi mr-0"><img class="th-icon" src="/assets/images/icons/setting.svg"></i> -->
                                <svg-icon class="" src="/assets/images/icons/closed-page-layout/setting.svg" [stretch]="true"
                                [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                            </button>
                        </div>
    
    
    
                    </div>
                </div>
    
            </div>
    
            <div class="card card-inner-products">
    
                <div class="card-body card-body_table">
                    <!-- <div class="card-body" #widgetsContent (wheel)="onWheel($event)"> -->
    
                    <!-- <div class="counter-products">
                        <button type="button" class="btn btn-primary btn-sm" (click)="chooseAllFiles()">
                            <i class="bi-check2-square"></i>{{ 'PRODUCT.SELECTED_ALL_PRODUCTS' | translate }}
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" (click)="unChooseAllFiles()">
                            <i class="bi-x-square"></i>{{ 'PRODUCT.UNSELECTED_ALL_PRODUCTS' | translate }}
                        </button>
                        <div class="counter-label">{{ 'PRODUCT.SELECTED_FILES' | translate }}: {{countSelectedFiles}}</div>
                    </div> -->
    
                    <table class="table table-hover">
                        <thead *ngIf="products && products.length > 0">
                            <tr>
                                <th scope="col" class="checkbox">
    
                                    <div class="btn-group me-3">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" name="select_all"
                                                id="select_all" [checked]="checkedCheckBox()"
                                                [indeterminate]="checkedButNotAllCheckBox()"
                                                (change)="checkAllCheckBox($event)">

                                            <label class="custom-control-label" for="select_all"></label>
                                        </div>
                                        <div class="btn-group" ngbDropdown role="group">
                                            <button type="button" class="btn btn-dropdown dropdown-toggle-split" ngbDropdownToggle placement="bottom"></button>
                                            <!-- <button type="button" class="btn btn-dropdown dropdown-toggle-split" ngbDropdownToggle  ngbTooltip="Выберите действие" placement="bottom"></button> -->
                                            <div class="dropdown-menu" ngbDropdownMenu>
                                                <button ngbDropdownItem>
                                                    <span (click)="chooseAllFiles()">
                                                        {{ 'PRODUCT.SELECTED_ALL_PRODUCTS' | translate }}
                                                    </span>
                                                </button>
                                                <button ngbDropdownItem>
                                                    <span (click)="unChooseAllFiles()">
                                                        {{ 'PRODUCT.UNSELECTED_ALL_PRODUCTS' | translate }}
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th scope="col" class="photo">Фото</th>
                                <th class="attr-fields"  *ngFor="let attr of getVisibleProductAttributes(products[0].attributes); let i = index"
                                    scope="col" class="{{attr.name}}" (click)="sortData(attr.id)">
                                    <div class="attr-block">
                                        <span 
                                            placement="bottom" 
                                            container="body" 
                                            class="mr-2">{{attr.name}}</span>
                                        <i *ngIf="checkDirection(attr.id) == ''  || isEmptyObject(sort)"><img
                                                class="th-icon" src="/assets/images/icons/sort-arrow.svg"></i>
                                        <i *ngIf="checkDirection(attr.id) == 'asc'"><img class="th-icon"
                                                src="/assets/images/icons/sort-asc.svg"></i>
                                        <i *ngIf="checkDirection(attr.id) == 'desc'"><img class="th-icon"
                                                src="/assets/images/icons/sort-desc.svg"></i>
                                    </div>
                                </th>
                                <th scope="col" class="filling">{{ 'Наполнение' | translate }}</th>
                                <th scope="col" class="status">{{ 'STATUS' | translate }}</th>
                                <th *ngIf="checkActions()" scope="col" class="action"></th>
                            </tr>
                        </thead>
    
                        <tbody *ngIf="products && products.length > 0">
                            <tr *ngFor="let product of products; let i = index">
                                <td class="checkbox">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" name="select_{{ i }}"
                                            id="select_{{ i }}" [checked]="product.checked"
                                            (change)="selectedCheckBox(i, $event)">
                                        <label class="custom-control-label" for="select_{{ i }}"></label>
                                    </div>
                                </td>
                                <td class="photo">
    
                                    <div class="block-photo" *ngIf="product.file_small && product.file_content">
    
                                        <div class="block-photo_inner" (click)="openModalViaService(product, 'preview')">
                                            <img src="{{ product.file_small }}">
                                            <div class="overlay">
                                              <i class="icon">
                                                <img src="/assets/images/icons/scale.svg" (click)="$event.stopPropagation(); openModalViaService(product, 'plus-icon')">
                                              </i>
                                            </div>
                                          </div>
                                    </div>
    
                                    <div class="block-no-photo" *ngIf="!product.main_photo">
                                        <img src="/assets/images/icons/no-photo.svg">
                                    </div>
                                </td>
    
                                <td class="attr-fields"  *ngFor="let attr of getVisibleProductAttributes(product.attributes); let j = index">
    
                                    <div class="attr-text-info">
    
                                        <div class="attr-text-visibility">
                                            <!-- 
                                            <div *ngIf="!showFiedlForEdit[i]" (click)="toProfile(product.id)" ngbTooltip="Смотреть" (contextmenu)="displayContextMenu($event, product, 'name')">
                                                {{ product.name }}
                                            </div> -->
    
                                            <!-- DISPLAY ATTRS VALUE -->
                                            <div class="attr-content"
                                                *ngIf="!attr.editable && (attr.present_type_id != 'TAGS' && attr.present_type_id != 'CERTIFICATE' && attr.present_type_id != 'FILE')"
                                                [ngbTooltip]="attr.display_value && attr.display_value.length > 25 ? attr.display_value : null"
                                                tooltipClass="clue-name"
                                                [closeDelay]="200"
                                                container="body">
                                                {{ attr.display_value }}
                                            </div>
    
                                            <!-- TAGS -->
                                            <div *ngIf="!attr.editable && attr.present_type_id == 'TAGS' && attr.attribute_additional_info != null">
    
                                                <table class="tags-table">
    
                                                    <tbody>
                                                        <tr class="addinfo-row"
                                                            *ngFor="let tag of attr.attribute_additional_info">
                                                            <td>
                                                                <div class="tag-box">
                                                                    <div *ngIf="tag.graphics_visible"
                                                                        [ngStyle]="getTagStyle(tag.tag_size_detail)">
                                                                        <div [innerHTML]="tag.tagHtml" [color]="tag.color">
                                                                        </div>
                                                                    </div>
                                                                    <div *ngIf="tag.text_visible"
                                                                        [ngStyle]="{'color': tag.font_color}">
                                                                        {{tag.name}}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
    
                                            </div>
    
                                            <!-- IF FILE -->
                                            <div *ngIf="!attr.editable && attr.present_type_id == 'FILE' && attr.attribute_additional_info != null">
    
                                                <table class="addinfo-table">
                                                    <tbody>
                                                        <tr class="addinfo-row"
                                                            *ngFor="let file of attr.attribute_additional_info; let i = index;">
                                                            <td class="addinfo-cell">
                                                                <div class="attr-text-visibility file-edit">
                                                                    <div class="attr-content">{{ file.name }}</div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <!-- <tr class="addinfo-row">
                                                             <td class="addinfo-cell">{{ attr.attribute_additional_info[0].name }}</td>
                                                        </tr> -->
                                                    </tbody>
                                                </table>
                                                
                                            </div>
    
                                            <!-- IF CERTIFICATE-->
                                            <div *ngIf="!attr.editable && attr.present_type_id == 'CERTIFICATE' && attr.attribute_additional_info != null">
    
                                                <table class="addinfo-table">
                                                    <tbody>
                                                        <tr class="addinfo-row">
                                                            <td class="addinfo-cell">
                                                                <div class="attr-content">{{attr.attribute_additional_info.file[0].name }}</div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
    
                                            <!-- EDIT ATTRS -->
                                            <div *ngIf="!attr.editable" class="text-edit-invisible">


                                                <span *ngIf="permissionAccess.check('ATTRIBUTE_VALUE_UPDATE') && attr.display_value != '' && attr.display_value != null">

                                                    <button class="btn btn-none" (click)="enableEdit(attr, product.id)">
                                                        <svg-icon src="/assets/images/icons/edit.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                                    </button>
                                                </span>

                                            </div>
    
                                        </div>

                                        <div *ngIf="permissionAccess.check('ATTRIBUTE_VALUE_UPDATE')">
                                            <div *ngIf="!attr.editable" class="attr-text-visibility none">
                                                <span *ngIf="attr.display_value == '' || attr.display_value == null">
                                                    <button class="btn btn-none" (click)="enableEdit(attr, product.id)">
                                                        <svg-icon src="/assets/images/icons/edit.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                                    </button>
                                                </span>
                                            </div>

                                        </div>

    
                                        <!-- <div class="attr-no-data"
                                            *ngIf="permissionAccess.check('ATTRIBUTE_VALUE_UPDATE') && !attr.editable && (attr.display_value == '' || attr.display_value == null)">
                                            <span>{{ 'NO_DATA' | translate }}</span>
                                        </div> -->
    
                                        <app-context-menu *ngIf="product.isContextMenu && contextFieldName=='name'"
                                                [contextMenuItems]="rightClickToProfile">
                                        </app-context-menu>
    
                                        <!-- <app-editable-content  class="attr-text-info-edit" -->
                                        <app-editable-content *ngIf="attr.editable" class="attr-text-info-edit"
                                            [inputValue]="{attrsData: attr, productData: product.id, defaultStyle: true}"
                                            (outputValue)="updateList(i, j, product, attr, $event)"
                                            (outputReject)="rejectEdit(attr)">
                                        </app-editable-content>
                                    </div>
    
                                </td>
    
                                <td class="filling">
                                    <div class="progress-bar_value">
                                        <div class="value-show">
                                            {{product.filling}}%
                                        </div>
                                        <div>
                                            <ngb-progressbar class="danger"
                                                *ngIf="product.filling >= 0 && product.filling <= 49" type="danger"
                                                textType="white" [value]="product.filling"></ngb-progressbar>
                                            <ngb-progressbar class="warning"
                                                *ngIf="product.filling >= 50 && product.filling <= 89" type="warning"
                                                textType="white" [value]="product.filling"></ngb-progressbar>
                                            <ngb-progressbar class="success" *ngIf="product.filling >= 90" type="success"
                                                textType="white" [value]="product.filling"></ngb-progressbar>
                                        </div>
                                    </div>
                                </td>
                                <td class="status">
                                    <div class="state" [ngClass]="product.state_id.toLowerCase()">
                                        {{ product.state_name }}
                                    </div>
                                </td>
                                <td *ngIf="checkActions()" class="action">
    
                                    <div class="action-btn">
    
                                        <app-context-menu *ngIf="product.isContextMenu && contextFieldName=='profile'"
                                            [contextMenuItems]="rightClickData" [ngStyle]="getRightClickMenuStyle()">
                                        </app-context-menu>
    
                                        <app-context-menu class="editContext"
                                            *ngIf="product.isContextMenu && contextFieldName=='edit'"
                                            [contextMenuItems]="rightClickData" [ngStyle]="getRightClickMenuStyle()">
                                        </app-context-menu>
    
                                        <button type="button" class="btn btn-none show-profile"
                                            *ngIf="permissionAccess.check('PRODUCT_PROFILE')"
                                            routerLink="/products/profile/{{ product.id }}" placement="left"
                                            ngbTooltip="Смотреть" tooltipClass="clue-name"
                                            (contextmenu)="displayContextMenu($event, product, 'profile')">
                                            <!-- <i class="bi bi-eye"></i> -->
                                            <svg-icon class="" src="/assets/images/icons/eye.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                        </button>
    
                                        <section class="action-btn_list">
    
                                            <ng-template class="btn-list" #popContent>
    
                                                <div class="btn-list_item"
                                                    *ngIf="permissionAccess.check('ADDINFO_EDIT', product.state_id)"
                                                    routerLink="/products/edit/{{ product.id }}"
                                                    (contextmenu)="displayContextMenu($event, product, 'edit')">
                                                    <span>{{ 'Редактировать' | translate }}</span>
                                                </div>
    
                                                <div class="list-item_delete"
                                                    *ngIf="permissionAccess.check('PRODUCTS_DELETE', product.state_id)"
                                                    (click)="onConfirm([product.id])">
                                                    <span>{{ 'Удалить' | translate }}</span>
                                                </div>
    
                                            </ng-template>
    
                                            <button type="button" placement="left" container="body" popoverClass="pop-custom-class" [ngbPopover]="popContent"
                                                [autoClose]="true" triggers="manual" #p="ngbPopover"
                                                class="btn btn-none action-btn_active btn-sm"
                                                popoverClass="my-custom-class"
                                                (click)="openWindowWithButton(p)"
                                                ngbTooltip="Действия">
                                                <svg-icon class="" src="/assets/images/icons/actions-more.svg" [stretch]="true"
                                                [svgStyle]="{'width.px':18, 'height.px':18}"><i class="bi bi-three-dots-vertical"></i> </svg-icon>
                                                <!-- <i class="bi bi-three-dots-vertical"></i> -->
                                            </button>
                                        </section>
    
                                    </div>
    
                                </td>
                            </tr>
                        </tbody>
    
                        <tbody class="loader-content" *ngIf="!products || products.length == 0">
                        <!-- <tbody class="loader-content" *ngIf="!products || products.length == 0"> -->
                            <tr scope="row">
                                <td *ngIf="loading" class="data-loading" colspan="products[0].attributes.length">
                                    <div class="spinner-bars">
                                        <div class="loadingio-spinner-bars-preLoder-inner">
                                            <div class="preLoder">
                                                <div></div><div></div><div></div><div></div>
                                            </div>
                                        </div>
                                        <div>{{ 'LOADING' | translate }}</div>
                                    </div>
                                </td>
                                <td *ngIf="!loading" class="data-not-found" colspan="products[0].attributes.length">
                                    <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                                </td>
                            </tr>
                        </tbody>
                        <!-- <div class="scroll-inner"></div> -->
                    </table>
                </div>

            </div>

            <div class="card-footer-pagination">
                <div class="pagination-component-products">
                    <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
                </div>
            </div>
            <!-- <div class="card">
            </div> -->
        <!-- </div> -->
    <!-- </div> -->
</div>

<div [ngClass]="{'gallertPerview': isGalleryOpen}">
    <ks-modal-gallery [attr.hidden]="isGalleryOpen === true ? null : 'true'"
        (close)="isGalleryOpen=false;" [id]="0" [modalImages]="activeGalleryImages"
        [plainGalleryGrid]="plainGalleryGrid"></ks-modal-gallery>
</div>
